import React, { lazy, Suspense } from 'react';

import PropTypes from 'prop-types';
import DesktopThankyouPopUp from './DesktopThankyouPopUp';
import { importWithRetry } from '../../lib/importWithRetry';
import { Button, Icon } from 'framework7-react';
import II18 from '../translate/II18';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_ID_CHECK,
  DOC_TYPE_PAYMENT
} from '../helpers/utils';
import { POPUP_THANKYOU } from '../desktop/DesktopMainPage';

const GalleryPopup = lazy(
  importWithRetry(() => import('../gallery/desktop/GalleryPopup'))
);
const IdCheckPopup = lazy(
  importWithRetry(() => import('../idCheck/desktop/IdCheckPopup'))
);
const Payment = lazy(
  importWithRetry(() => import('../payment/desktop/PaymentPopup'))
);

export default function DesktopPopup(props) {
  const {
    actionDocument,
    popupId,
    onPopupClose,
    companyName,
    scanEnded
  } = props;

  const popupPreloader = (
    <div className="desktop-preload">
      <label>{II18.get('title_loading')}...</label>
      <Button onClick={() => onPopupClose(popupId)}>
        <Icon material={'close'} /> {II18.get('title_cancel')}
      </Button>
    </div>
  );

  return popupId === DOC_TYPE_DOCUMENT ? (
    <Suspense fallback={popupPreloader}>
      <GalleryPopup
        requestedDocumentId={actionDocument.id}
        onDocumentClose={() => onPopupClose()}
        maxPages={0}
        scanEnded={scanEnded}
      />
    </Suspense>
  ) : popupId === DOC_TYPE_ID_CHECK ? (
    <Suspense fallback={popupPreloader}>
      <IdCheckPopup
        requestedDocumentId={actionDocument.id}
        onDocumentClose={() => onPopupClose()}
      />
    </Suspense>
  ) : popupId === DOC_TYPE_PAYMENT ? (
    <Suspense fallback={popupPreloader}>
      <Payment
        requestedDocumentId={actionDocument.id}
        onDocumentClose={() => onPopupClose()}
      />
    </Suspense>
  ) : (
    popupId === POPUP_THANKYOU && (
      <DesktopThankyouPopUp
        onClosePopUp={() => onPopupClose(POPUP_THANKYOU)}
        companyName={companyName}
      />
    )
  );
}

DesktopPopup.propTypes = {
  popupId: PropTypes.any.isRequired,
  onPopupClose: PropTypes.func,
  actionDocument: PropTypes.object,
  companyName: PropTypes.string,
  scanEnded: PropTypes.bool
};
